export class ConfirmDialogModel {
    text?:string;
    returnValue?:boolean;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/generc_dialogs/confirmDialogModel.ts